<template>
    <div class="container" :style="{backgroundImage:'url('+ bg +')'}">
      <div class="main" v-if="isOpen">
        <div class="" v-for="(item,index) in currentLsit.content" :key="index">
      <img :src="require(`../assets/images/内容页/${item.btn}`)" alt="" draggable="false"  @click="goVR(item)"/>
      </div>
      </div>

      <div class="back-icon-box" @click="backPage">
      <img :src="backIcon" class="back-icon" />
    </div>
    <div v-show="iframeOpen" class="iframe-box">
      <iframe :src="iframeUrl" height="100%" width="100%" frameborder="no"></iframe>
    </div>
    <div v-show="iframeOpen" class="back-iframe-box" @click="closeIframe">
      <img :src="backIcon" class="back-icon" />
    </div>
    <!-- @stopAllSound="stopAllSound"
        @gameOver="gameOver" -->
    <Redian
        ref="redians"
        style="z-index: 999"
      ></Redian>
    </div>
  </template>
  
  <script>
  import {SpriteJson} from "@/api";
  import Redian from "@/components/redian.vue";
  import backIcon from "@/assets/back.png";

  export default {
    name: "ContentSprite",
    data() {
      return {
        bg:"",
        backIcon,
        spriteJson:{},
        currentLsit:undefined,
        SpriteJson,
        iframeOpen:false,
        isOpen:false,
        iframeUrl:"",
        id:""
      };
    },
    components: {Redian},
    created(){
      SpriteJson().then(res=>{
      let that =this
      that.spriteJson = res
      that.id = this.$route.params.id
     for (const key in  that.spriteJson) {
      if (Object.hasOwnProperty.call(that.spriteJson, key)) {
        if(that.id  == that.spriteJson[key].nav){
          that.currentLsit = that.spriteJson[key]
          break;
        }
      }
     }
     that.bg = require(`../assets/images/内容页/内容页/中国精神-${that.currentLsit.name}内容页.png`)
    that.isOpen = true
    })
    },
     mounted(){
    
    },
    methods: {
    backPage() {
      this.$router.push("/navPage");
    },
		GetXuebeiURL(url, name) {
			var vfd = [];
			var vfdUnit = {};
			vfdUnit.version = '2.0';
			vfdUnit.accessKey = 'DshEpGC9CoIV7FiV';
			vfdUnit.launchType = 'web';
			vfdUnit.url = url;
			vfdUnit.title = name;
			vfdUnit.groupCount = 35;
			vfdUnit.id = '123456';
			vfd.push(vfdUnit);
			console.log(vfd)
			var str = url + '?walkclassvfd=' + encodeURIComponent(JSON.stringify(vfd));
			return str;
		},
		openXuebei(url, name) {
			// let url = `http://ve.cool360.com/${id}/index.html`;
			let xuebeiprojectID = this.GetXuebeiURL(url, name);
      console.log(xuebeiprojectID);
		},
    goVR(item){
      this.openXuebei("http://ve.cool360.com/spritePage/index.html","大沙盘")
      console.log(window.location.search.indexOf("?"));
      if(item.btn == "点击查看数字博物馆.png"){
        if(item.btnUrl){
          if(window.location.search.indexOf("?")!==-1){
          this.iframeUrl = `https://ve.cool360.com/${item.btnUrl}/index.html` + window.location.search
          }else{
            if(item.xuebei)
            this.iframeUrl = `https://ve.cool360.com/${item.btnUrl}/index.html` + item.xuebei
            else
            this.iframeUrl = `https://ve.cool360.com/${item.btnUrl}/index.html` 
          }
        console.log(this.iframeUrl);
        this.iframeOpen = true
        }
      }else if(item.btn == "点击查看精神印记.png"){
        this.$refs.redians.init(item.btnUrl);
      }else{
        if(item.btnUrl){
          if(window.location.search.indexOf("?")!==-1){
          this.iframeUrl = `https://vm.cool360.com/${item.btnUrl}/index.html` + window.location.search
          }else{
            if(item.xuebei)
            this.iframeUrl = `https://vm.cool360.com/${item.btnUrl}/index.html` + item.xuebei
            else
            this.iframeUrl = `https://vm.cool360.com/${item.btnUrl}/index.html`
          }
          console.log(this.iframeUrl);
          this.iframeOpen = true
        }
      }
    },
    closeIframe(){
      this.iframeOpen = false
      this.iframeUrl = ""
    }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    min-width: 1100px;
    min-height: 720px;

  }
  .main{
      display: flex;
      position: relative;
      top: 85%;
      justify-content: center;
      div{
        margin: 0 60px;
        cursor: pointer;
        img{
          height: 91px;
        }
      }
  }
  .footer{
    position: relative;
      display: flex;
      justify-content: right;
      top: 28%;
      img{
        height: 42px;
        margin-right: 100px;
      }
  }
  .back-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50px;
    top: 45%;
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .back-iframe-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50px;
    top: 45%;
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 5;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .iframe-box{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

  </style>